/**
 * Functions for transitioning from typescript-monads' `maybe` to fp-ts' `Option`.
 */
import { IMaybe } from 'typescript-monads/interfaces'
import { fromNullable, Option } from 'fp-ts/Option'

/**
 * Convert a Maybe to an Option directly.
 *
 * Maybe doesn't allow nullish internal values like Option does, so the Option
 * will always contain a non-nullish type when it is returned.
 */
export function fromMaybe<A>(m: IMaybe<A>): Option<A> {
  return fromNullable(m.valueOrUndefined())
}
